import React, { useEffect, useState } from "react";
import { Card, Col, Row, OverlayTrigger, Popover, Form } from "react-bootstrap";
import "./mxmatchhowmuchcash.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import dayjs from "dayjs";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useSelector } from "react-redux";
import { addCommas } from "../../helpers/helpers";
import { ModalOverlay } from "../../atoms/Modal";

export const MixMatchHowMuchCash = (props) => {
  const { choose } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const [sliderValue, setSliderValue] = useState(0);
  const detailsData = JSON.parse(localStorage.getItem("choose"));
  const [taxfreemodal, setTaxfreemodal] = useState(false);

  const totalCash =
    Object.keys(choose).length === 0
      ? detailsData?.monetaryChosenAmount
      : choose?.monetaryChosenAmount; // eslint-disable-line

  const maxTaxFreeCash = totalCash * 0.25;
  const taxFreeCash = Math.min((sliderValue / 100) * totalCash, maxTaxFreeCash);
  const movingToDrawdown = addCommas(
    (totalCash - (sliderValue / 100) * totalCash).toFixed(2) //eslint-disable-line
  );
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");

  const handleSliderChange = (e) => {
    const percentage = parseFloat(e.target.value);
    setSliderValue(percentage);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace("%", "");
    if (inputValue === "") {
      setSliderValue("0");
    } else {
      const percentage = parseFloat(inputValue);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
        setSliderValue(percentage);
      }
    }
  };

  useEffect(() => {
    updateSliderBackground(sliderValue);
  }, [sliderValue]);

  const updateSliderBackground = (value) => {
    const percentage = ((value - 0) / (100 - 0)) * 100;
    const slider = document.querySelector(".custom-slider");
    slider.style.background = `linear-gradient(to right, var(--blue-100) 0%, var(--blue-100) ${percentage}%, var(--white) ${percentage}%, var(--white) 100%)`;
  };

  const handleBack = () => {
    props.makeInitialStepper(false, 33, { isRetirementChoice: true }, true);
  };
  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_MM_CASH_LUMPSUM;
    let mixNmatch = {
      cashLumpsum: {
        amount: parseInt(movingToDrawdown.replace(",", "")).toFixed(2),
        percentage: sliderValue,
      },
    };
    let payload = {
      currentStep,
      choiceCategory: { mixNmatch },
    };
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_MM_CASH_LUMPSUM, payload);
  };

  return (
    <>
      <Card className="application-step">
        <Card.Body className="how-much-cash">
          <h2 className="heading">How much cash would you like to take?</h2>
          <p>
            You can take <span className="fw-bold">25% tax-free</span> and
            anything over that will be taxed.
          </p>
          <p>
            Use the slider or form field below to let us know how much
            you&apos;d like to take as a cash lump sum. You can then use the
            rest to get a regular income.
          </p>
          <Card className="bottom-bg-card mb-4">
            <Card.Body>
              <Row className="bottom-card-content">
                <Col md={6} className="description-text">
                  <p>
                    Let us know the cash lump sum you wish to take by entering
                    the percentage or using the slider.
                  </p>
                  <p>
                    You can take up to 25% tax free. Any taxable portions will
                    be paid separately from drawdown, shortly after the tax-free
                    amount.
                  </p>
                  <p>
                    <span className="left-txt">Applying with</span>{" "}
                    &emsp;&emsp;&emsp;&emsp;
                    <span className="amount-text fw-bold">
                      {"£" + addCommas(totalCash?.toFixed(2))}
                    </span>
                  </p>
                  <p className="form-field-mam taking-cash">
                    <span>Taking as cash</span>
                    <input
                      type="text"
                      className="input-text"
                      value={`${sliderValue}%`}
                      onChange={handleInputChange}
                      min="0"
                      max="100"
                    />
                  </p>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={8} className="text-left">
                      <p>Of which tax-free cash</p>
                      <p>Moving to TPT drawdown</p>
                      <p>Of which taxable cash</p>
                    </Col>
                    <Col md={4} className="text-right bld p-0">
                      <p>{"£" + addCommas(taxFreeCash.toFixed(2))}</p>
                      <p className="moving-to-drawdown">
                        {"£" + movingToDrawdown}
                      </p>
                      <p className="taxable-cash">
                        {"£" +
                          addCommas(
                            (
                              (sliderValue / 100) * totalCash -
                              taxFreeCash
                            ).toFixed(2) // eslint-disable-line
                          )}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div>
                <p className="slider-value">
                  <span className="static">0%</span>
                  <span className="static text-right">100%</span>
                </p>
                <Form.Range
                  value={sliderValue}
                  name="MixAndMatchSlider"
                  max={100}
                  onChange={handleSliderChange}
                  className="custom-slider"
                />
              </div>
              <Row>
                <div className="tax-icons">
                  <span className="tax-free">
                    Tax-free{" "}
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Popover
                          id="popover-contained"
                          className="tooltip-popover-section custom-popover"
                        >
                          <Popover.Body className="tooltip-popover-body-how-much-cash">
                            <div>
                              <p>
                                You can usually take up to 25% of your pension
                                as a tax-free cash lump sum. Any portion over
                                25% will be subject to income tax when you take
                                it.{" "}
                              </p>
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                      flip={true}
                    >
                      <span className="textarea-tooltip">
                        <Icons variant="icon-thirteen-px" iconname="tool-tip" />
                      </span>
                    </OverlayTrigger>
                  </span>
                  <span className="taxable">
                    Taxable{" "}
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Popover
                          id="popover-contained"
                          className="tooltip-popover-section custom-popover"
                        >
                          <Popover.Body className="tooltip-popover-body-how-much-cash">
                            <div>
                              <p>
                                Taking a taxable portion will limit the maximum
                                amount that you can pay into a pension in the
                                future. This is called the Money Purchase Annual
                                Allowance.
                              </p>
                            </div>
                          </Popover.Body>
                        </Popover>
                      }
                      flip={true}
                    >
                      <span className="textarea-tooltip">
                        <Icons variant="icon-thirteen-px" iconname="tool-tip" />
                      </span>
                    </OverlayTrigger>
                  </span>
                </div>
              </Row>
              <div className=" m-42 d-flex align-items-center">
                <div className="value-correct-date">
                  {" "}
                  Values correct as of {todayDate}
                </div>
                <OverlayTrigger
                  placement="left"
                  overlay={
                    <Popover
                      id="popover-contained"
                      className="tooltip-popover-section custom-popover"
                    >
                      <Popover.Body className="tooltip-popover-body-how-much-cash">
                        <p>
                          {" "}
                          All the values are estimates, based on the most
                          accurate information available. They include all the
                          contributions paid by you and your employer.
                        </p>
                        <p>
                          The value of your pension savings is based on current
                          financial conditions and is not guaranteed. The
                          amounts you receive may be higher or lower than the
                          amounts shown above. Payment of your pension will be
                          subject to TPT’s Trust Deed and Rules, and regulatory
                          requirements.
                        </p>{" "}
                      </Popover.Body>
                    </Popover>
                  }
                  flip={true}
                >
                  <span className="textarea-tooltip">
                    <Icons iconname="tool-tip" variant="icon-twelve-px" />
                  </span>
                </OverlayTrigger>
              </div>
            </Card.Body>
          </Card>

          <Row className="button-container">
            <Col md={6}>
              {" "}
              <Buttons
                handleClick={handleBack}
                className="secondary back-btn"
                name="Back"
              />
            </Col>
            <Col md={6} className="text-end">
              <Buttons
                handleClick={() => handleContinue()}
                className="primary"
                name="Continue"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <ModalOverlay
        popup="fc-taxfree-modal"
        show={taxfreemodal}
        onHide={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setTaxfreemodal(false);
        }}
        handleClick={(e) => {
          if (e !== undefined) {
            e.preventDefault();
          }
          setTaxfreemodal(false);
        }}
      />
    </>
  );
};
export default MixMatchHowMuchCash;
